import { render, staticRenderFns } from "./areaCard.vue?vue&type=template&id=59070412&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./areaCard.vue?vue&type=style&index=0&id=59070412&lang=stylus&scoped=true&"
import style1 from "./resetvant.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59070412",
  null
  
)

export default component.exports